<div class="map-toolbar">
  <div
    [matTooltip]="is3D() ? 'Switch to 2D mode to access Custom Elements.' : !displayPanel ? 'Custom Elements Detection' : ''"
    matTooltipPosition="right">
    <button
      matIconButton
      class="mat-icon-toggle-button"
      [class.selected]="displayPanel && !is3D()"
      [disabled]="is3D()"
      type="button"
      (click)="togglePanelDisplay()">
      <mat-icon>image_search</mat-icon>
    </button>
  </div>

  <div class="toolbar-panel-container" [hidden]="!displayPanel || is3D()">
    <div class="custom-elements-toolbar-panel">
      <lib-custom-elements-panel (closeRequested)="togglePanelDisplay()" />
    </div>
  </div>
</div>

<!-- Processing overlay — rendered outside the panel, covers the map.
     Only shown when a detection run is active. -->
@if (detection.stage() === 'processing') {
  <lib-processing-overlay />
}